import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DialogResult } from '../../../interfaces/dialog.interface';

export interface VersionUpdateData {
  newVersion: string;
  currentVersion: string;
  buildDate: string;
}

@Component({
  selector: 'app-version-update-dialog',
  templateUrl: './version-update-dialog.component.html',
  styleUrl: './version-update-dialog.component.scss',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VersionUpdateDialogComponent {
  readonly data = inject<VersionUpdateData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<VersionUpdateDialogComponent>);

  get formattedDate(): string {
    return new Date(this.data.buildDate).toLocaleDateString('es-CL');
  }

  onConfirm(): void {
    const result: DialogResult = { confirmed: true };
    this.dialogRef.close(result);
  }

  onCancel(): void {
    const result: DialogResult = { confirmed: false };
    this.dialogRef.close(result);
  }
}
